import { Form } from 'antd';
import React from 'react';
import styles from './ShutdownForm.module.scss';
import {
  CityField,
  CompanyField,
  InitiatorsField,
  PlanEndDateField,
  ReasonField,
  StartDateField,
  TypeField,
  MainInitiatorField,
  ResponsibleField,
  NotifyToField,
  EndDateField,
  EnableAlisaField,
  AlisaTemplateField,
  AlisaTextField,
  DescriptionField,
  UploadFilesField,
  AddressesField,
  EnableCompanyAlisaField,
} from '../../common';
import CountFlat from '../../common/CountFlat/CountFlat';

const ShutdownForm = ({ form, renderResTemplateAction }) => {
  return (
    <Form>
      <CompanyField form={form} />
      <CityField form={form} />
      <div className={styles.flexBox}>
        <StartDateField form={form} />
        <PlanEndDateField form={form} />
      </div>
      <div className={styles.flexBox}>
        <ReasonField form={form} />
        <TypeField form={form} />
      </div>
      <div className={styles.flexBox}>
        <InitiatorsField form={form} />
        <MainInitiatorField form={form} />
      </div>
      <div className={styles.flexBox}>
        <ResponsibleField form={form} />
        <NotifyToField form={form} />
      </div>
      <div className={styles.flexBox}>
        <EndDateField form={form} />
        <AlisaTemplateField
          form={form}
          renderAction={renderResTemplateAction}
        />
      </div>
      <div className={styles.flexBox} style={{ alignItems: 'end' }}>
        <EnableAlisaField form={form} />
        <EnableCompanyAlisaField form={form} />
      </div>
      <AlisaTextField form={form} />
      <DescriptionField form={form} />
      <UploadFilesField form={form} />
      <CountFlat form={form} />
      <AddressesField form={form} />
    </Form>
  );
};

export default ShutdownForm;
